import TextField from "@material-ui/core/TextField";
import styles from "modules/shared/components/inputs/css/BorderedTextArea.css";
import React from "react";

function rootClasses(props) {
  const { withBottomMargin } = props;

  if (withBottomMargin) {
    return styles.root;
  }
}

export default function BorderedTextArea(props) {
  const { labelShrink, customProps, error, ...textAreaProps } = props;
  const { rows, rowsMax } = textAreaProps;

  const helperClasses = [styles.form_helper_text_root];

  if (error) {
    helperClasses.push(styles.form_helper_text_root_error);
  }

  return (
    <TextField
      multiline
      fullWidth
      variant="outlined"
      rows={rows}
      rowsMax={rowsMax}
      classes={{
        root: rootClasses({ ...defaultCustomProps, ...customProps }),
      }}
      InputProps={{
        classes: {
          disabled: styles.disabled,
          input: styles.input,
          notchedOutline: styles.notched_outline,
        },
        ...customProps,
      }}
      InputLabelProps={{
        classes: {
          outlined: styles.outlined,
          root: styles.input_label_root,
          shrink: labelShrink,
        },
      }}
      FormHelperTextProps={{
        classes: {
          root: helperClasses.join(" "),
        },
        margin: "dense",
      }}
      error={!!error}
      {...textAreaProps}
    />
  );
}

const defaultCustomProps = {
  withBottomMargin: true,
};

BorderedTextArea.defaultProps = {
  customProps: defaultCustomProps,
  rows: 3,
  rowsMax: 3,
};
